'use client'

import React, { useEffect, useRef, useState } from "react"
import { useSearchParams, usePathname, useRouter } from "next/navigation"
import { useDebounceCallback } from "usehooks-ts"
import Checkbox from "@/components/form/Checkbox"
import RangeSlider from "@/components//form/RangeSlider"
import { changeFilters, convertsURLSearchParamsToObject, toggleFilter } from "@/services/search"
import { environments, thematics } from "@/services/holidayStay"
import DateMask from "../form/DateMask"
import moment from "moment"

type FiltersProps = {
    aroeven: Aroeven,
    contextSearchParams: any,
    facets: any
}

export default function Filters({
    aroeven,
    contextSearchParams,
    facets
}: FiltersProps) {

    const searchParams = useSearchParams()
    const pathname = usePathname()
    const { replace } = useRouter()
    //const [facets, setFacets] = useState({})    

    const changeFiltersWithDebounce = useDebounceCallback((filters: any) => {
        replace(`${pathname}?${changeFilters(searchParams, filters).toString()}`, {
            scroll: false
        })
    }, 300)

    /*useEffect(() => {
        async function updateFacets() {
            const { facets: newFacets } = await searchHolidayStays(aroeven, {
                ...convertsURLSearchParamsToObject(searchParams),
                ...contextSearchParams
            })
            setFacets(newFacets)
        }
        updateFacets()
    }, [searchParams])*/


    return (
        <>
            <aside className="sidebar filtres bg-bloc y-gap-40">
                <div className="sidebar__item">
                    <h4 className="text-18 mb-20">Date</h4>
                    <div className="form-input date mb-10">
                        <DateMask
                            onChange={(date) => {
                                changeFiltersWithDebounce({
                                    minDate: date                                    
                                })
                            }}
                            value={searchParams.get('minDate') ? moment(searchParams.get('minDate'), 'YYYY-MM-DD')?.format('DD/MM/YYYY') ?? '' : ''}
                        />
                        <label className="lh-1 text-light-1">
                            Début à partir de :
                        </label>
                    </div>
                    <div className="form-input date">
                        <DateMask
                            onChange={(date) => {
                                changeFiltersWithDebounce({
                                    maxDate: date                                    
                                })
                            }}
                            value={searchParams.get('maxDate') ? moment(searchParams.get('maxDate'), 'YYYY-MM-DD')?.format('DD/MM/YYYY') ?? '' : ''}
                        />
                        <label className="lh-1 text-light-1">
                            Fin avant le :
                        </label>
                    </div>
                </div>
                <div className="sidebar__item">
                    <h4 className="text-18 mb-20">Type</h4>
                    <div className="sidebar-checkbox">
                        {Object.entries(environments).map(([key, data], index) => {
                            const searchParam = 'environment'
                            return (
                                <React.Fragment key={"checkbox-" + index}>
                                    <div className="d-flex items-center justify-content-between">
                                        <Checkbox
                                            defaultChecked={searchParams.get(searchParam)?.split(',').includes(key) ?? false}
                                            toggle={() => replace(`${pathname}?${toggleFilter(searchParams, searchParam, key).toString()}`, {
                                                scroll: false
                                            })}
                                            label={data.name}
                                        />
                                        <div className="col-auto">
                                            <div className="text-15 text-light-1">{searchParam in facets && Array.isArray(facets[searchParam]) && facets[searchParam].filter(f => f.value === key).length > 0 ? <>{facets[searchParam].filter(f => f.value === key)[0].count}</> : 0}</div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )
                        })}
                    </div>
                </div>
                <div className="sidebar__item pb-30">
                    <h4 className="text-18 mb-20">Tarif</h4>
                    <div className="row x-gap-10 y-gap-30">
                        <div className="col-12">
                            <RangeSlider
                                min={parseInt(searchParams.get('minPrice') ?? "0")}
                                max={parseInt(searchParams.get('maxPrice') ?? "2000")}
                                rangeMin={0}
                                rangeMax={2000}
                                onChange={(values: number[]) => {
                                    changeFiltersWithDebounce({
                                        minPrice: values[0],
                                        maxPrice: values[1]
                                    })
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="sidebar__item">
                    <h4 className="text-18 mb-20">Thématique</h4>
                    <div className="sidebar-checkbox">
                        {Object.entries(thematics).map(([key, data], index) => {
                            const searchParam = 'thematic'
                            return (
                                <React.Fragment key={"checkbox-" + index}>

                                    <div className="d-flex items-center justify-content-between">
                                        <Checkbox
                                            defaultChecked={searchParams.get(searchParam)?.split(',').includes(key) ?? false}
                                            toggle={() => replace(`${pathname}?${toggleFilter(searchParams, searchParam, key).toString()}`, {
                                                scroll: false
                                            })}
                                            label={data.name}
                                        />
                                        <div className="col-auto">
                                            <div className="text-15 text-light-1">{searchParam in facets && Array.isArray(facets[searchParam]) && facets[searchParam].filter(f => f.value === key).length > 0 ? <>{facets[searchParam].filter(f => f.value === key)[0].count}</> : 0}</div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )
                        })}
                    </div>
                </div>
                <div className="col-12 pb-0 pt-10">
                    {/*<a href="#" className="button-primary d-block w-100">
                        Filtrer les résultats
                    </a>*/}
                    <a href="#" onClick={(e) => {
                        e.preventDefault()
                        replace(`${pathname}`, {
                            scroll: false
                        })
                    }}>
                        <span className="info d-flex justify-content-center mt-10">
                            <i className="fi fi-ss-circle-xmark mr-5" />
                            Annuler tous les filtres
                        </span></a>
                </div>
            </aside>
        </>
    )
}